enum ActiveStatusEnum {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
}

export default ActiveStatusEnum;
